import React from 'react';
import { ExposureWidgetItemBrand } from '../../../../../../../types/widget';
import Img from '../../../../../../../components/Img/Img';
import { BrandSimpleCardStyle } from './style';

interface BrandSimpleCardProps {
  widgetBrandItem: ExposureWidgetItemBrand;
}

const BrandSimpleCard = (props: BrandSimpleCardProps) => {
  const { widgetBrandItem } = props;

  return (
    <BrandSimpleCardStyle>
      <Img clickAble={false} src={widgetBrandItem.brand.imageUrl} />
      <div className="title">
        {widgetBrandItem.title || <span className="require-info">위젯 브랜드 아이템 타이틀을 설정해주세요.</span>}
      </div>
    </BrandSimpleCardStyle>
  );
};

export default BrandSimpleCard;
